import './polyfill';
import './localisation';
import './utils/iframeResizer.embed';

import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import $ from 'jquery';

import VueLazyLoad from 'vue-lazyload';
import BootstrapVue from 'bootstrap-vue';
import VueRouter from 'vue-router';
import * as numeral from 'numeral';
import numFormat from 'vue-filter-number-format';

import * as Logger from 'js-logger';

import Config from './config.json';

import * as Store from './store';
import { store } from './store';

import router from './router';

import WidgetLayout from './components/layout';

// Styles and fonts
import '../node_modules/font-awesome/css/font-awesome.min.css';

import template from './main.vue';

import WebsocketClient, { WebsocketsListener } from './utils/ws';

// Init websocket client
new WebsocketClient();

numeral.register('locale', 'ro', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'mil',
        billion: 'mld',
        trillion: 't'
    },
    ordinal : function (number: number) {
        return number === 1 ? 'er' : 'ème';
    },
    currency: {
        symbol: '€'
    }
});

numeral.locale('ro');


const logLevel = (Config.debug ? Logger.DEBUG : Logger.ERROR);
Logger.useDefaults();
Logger.setLevel(logLevel);
Vue.filter('numFormat', numFormat);
Vue.use(VueLazyLoad);
Vue.use(BootstrapVue);

Vue.config.productionTip = false;

Vue.config.errorHandler = function (err, vm, info) {
    Logger.error('Vue error: ', err);
};

// Get user data from localstorage
let userData: any;
const userDataString = localStorage.getItem('hud');
if (userDataString) {
    try {
        userData = JSON.parse(userDataString);
    } catch (e) {

    }
}

@Component({
    mixins: [template],
    store,
    components: {
        WidgetLayout,
    },
    router,
})

class App extends Vue {

    wsListener: WebsocketsListener

    constructor() {
        super();
        this.wsListener = new WebsocketsListener();
    }

    mounted() {
        // Assign session values to store for global dispatch
        this.wsListener.onGet('wss.session', (success: boolean, data: any) => {

            if (success) {

                this.wsListener.setAuthState(success, data);

                Store.commitLoggedInUser(this.$store, data);
                Store.commitLoggedInState(this.$store, true);

                this.wsListener.sendGet('auth.profile')

            }
            else {
                Store.commitCheckingSession(this.$store, false);
            }

        });

        this.wsListener.onGet('auth.profile', (success: boolean, data: any) => {

            if (data.verification && data.verification.status == 1) {
                Store.commitVerifcationInProgress(this.$store, true);
            }

            Store.commitCheckingSession(this.$store, false);

        });

    }

    isCheckingSession() {
        return Store.readCheckingSession(this.$store);
    }

    isLoggedIn() {
        return Store.readLoggedInState(this.$store);
    }

    hasLoaderActive() {
        return Store.readLoaderVisibility(this.$store);
    }
}

window.onerror = function (errorMsg, url, lineNo, colNo, error) {
    Logger.error('Global event: ', errorMsg);
    Store.commitLoaderVisibility(store, false);
};

export const app = new App().$mount('#app');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/main.ts